/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

const SubLabel = styled.h5`
  font-weight: normal !important;
  padding: 0.5em 1em 0.5em 1em !important;
  font-size: "19px" !important;
  font-family: "Source Sans Pro" !important;
`;

const ModalAsistencias = ({
  baseClassName = "w-100 text-center text-md-left mt-3",
  className = "",
  ocupaciones = [],
  label = "Ver asistencias",
}) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <React.Fragment>
      <div className={`${baseClassName} ${className}`} style={{ paddingLeft: "1em" }}>
        <a
          className='font-futura-medium text-underline-hover cpointer text-mex text-popuoauto'
          style={{
            fontSize: "20px",
            color: "#e46f1f !important",
          }}
          onClick={() => {
            setModalShow(true);
          }}>
          {label}
        </a>
      </div>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {ocupaciones?.map((seccion, index) => (
            <div key={index}>
              {!seccion?.sublabel && (
                <h4 style={{ marginBottom: "2rem" }}>{seccion?.label}</h4>
              )}
              {seccion?.sublabel && <SubLabel>{seccion?.label}</SubLabel>}
              <List>
                {seccion?.datos?.map((item, index) => (
                  <li key={item?.id} className='mt-3 d-flex flex-row'>
                    {index + 1 > 9 && (
                      <span style={{ paddingRight: "10px", marginLeft: "-0.5em" }}>
                        {index + 1})
                      </span>
                    )}
                    {index + 1 <= 9 && (
                      <span style={{ paddingRight: "10px" }}>{index + 1})</span>
                    )}
                    <span>{item?.nombre}</span>
                  </li>
                ))}
              </List>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-primary' onClick={() => setModalShow(false)}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalAsistencias;

const List = styled.ul`
  font-size: 18px;
  list-style: none;
  font-family: "Source Sans Pro", Arial, Helvetica, sans-serif;
  font-weight: 500 !important;
  & > li {
    @media (min-width: 550px) {
      width: 450px !important;
    }
    @media (min-width: 650px) {
      width: 550px !important;
    }
    @media (min-width: 750px) {
      width: 650px !important;
    }
  }
`;
